export default __webpack_public_path__ + "static/media/icra-monitoring-agency-report.9814b60c.pdf";